var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataScienceBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "#E6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4967 24.1882C25.0508 22.5773 22.9893 17.8286 18.8922 13.5816C14.7952 9.33467 10.214 7.19774 8.65998 8.80865C7.10593 10.4196 9.16744 15.1683 13.2645 19.4152C17.3616 23.6622 21.9427 25.7991 23.4967 24.1882Z",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8922 19.4184C22.9893 15.1714 25.0508 10.4227 23.4967 8.81178C21.9427 7.20087 17.3616 9.3378 13.2645 13.5848C9.16744 17.8317 7.10593 22.5804 8.65998 24.1914C10.214 25.8023 14.7952 23.6653 18.8922 19.4184Z",
    stroke: "#00A0B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0765 17.625C16.6759 17.625 17.1618 17.1213 17.1618 16.5C17.1618 15.8787 16.6759 15.375 16.0765 15.375C15.4771 15.375 14.9912 15.8787 14.9912 16.5C14.9912 17.1213 15.4771 17.625 16.0765 17.625Z",
    fill: "#00A0B1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataScienceBlue);
export default __webpack_public_path__ + "static/media/dataScience-blue.0728b82b31217ccfdfa42a90e8704f47.svg";
export { ForwardRef as ReactComponent };